<template>
    <div v-show="disableDeliveryMessage" class="cart-product-list-responsive__delivery-estimate">
        <div class="cart-product-list-responsive__delivery-estimate-title-wrapper">
            <h2 class="cart-product-list-responsive__delivery-estimate-title">{{ $t("checkout.delivery") }}</h2>
            <i class="fas fa-truck cart-product-list-responsive__delivery-estimate-icon"></i>
        </div>
        <div class="cart-product-list-responsive__delivery-estimate-content-wrapper">
            <div>
                <p>
                    <span class="">{{ $t('checkout.between') }} </span>
                    <span v-text="deliveryDayBetween.from" class="cart-product-list-responsive__delivery-estimate-days"></span>
                    <span class=""> {{ $t('checkout.and') }} </span>
                    <span v-text="deliveryDayBetween.until" class="cart-product-list-responsive__delivery-estimate-days"></span>
                    <span class="" v-if="deliveryDayBetween.disableTimer"> {{ $t('checkout.days') }} </span>
                </p>
            </div>
            <p v-if="countdownTimer" class="cart-product-list-responsive__delivery-estimate-countdown-timer">{{ $t("checkout.countdownMessage1") }} <span v-text="countdownTimer"></span> {{ $t("checkout.countdownMessage2") }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckoutDeliveryEstimate",
    components: {},
    props: {
        deliveryDayBetween: {
            type: Object,
            required: true,
        },
        fastestDeliveryUntil: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            timeRemaining: null,
        };
    },
    methods: {
        disableDeliveryMessage() {
            const currentDate = new Date();
            const targetDate = new Date(2025, 0, 2);

            return currentDate < targetDate;
        },
        getTimeRemaining(endtime) {
            const total   = Date.parse(endtime) - Date.parse(new Date());
            const seconds = Math.floor((total / 1000) % 60);
            const minutes = Math.floor((total / 1000 / 60) % 60);
            const hours   = Math.floor((total / (1000 * 60 * 60)) % 24);
            const days    = Math.floor(total / (1000 * 60 * 60 * 24));

            return {
                total,
                days,
                hours,
                minutes,
                seconds
            };
        },
        addLeadingDigit(digit) {
            if (digit > 9) {
                return String(digit);
            }

            return "0" + String(digit);
        }
    },
    computed: {
        countdownTimer() {
            if (this.deliveryDayBetween.disableTimer) {
                return null;
            }

            if (!this.timeRemaining) {
                return null;
            }

            if (this.timeRemaining.hours < 0 || this.timeRemaining.days > 0) {
                return null;
            }

            return `${this.timeRemaining.hours}:${this.addLeadingDigit(this.timeRemaining.minutes)}:${this.addLeadingDigit(this.timeRemaining.seconds)}`;
        }
    },
    mounted() {
        this.timeRemaining = this.getTimeRemaining(this.fastestDeliveryUntil);

        setInterval(() => {
            this.timeRemaining = this.getTimeRemaining(this.fastestDeliveryUntil);
        }, 1000);
    }
};
</script>
